"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhiteCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const WhiteCard = ({ onClick, href, LinkComponent, children, actionSx = [], sx = [], }) => {
    const cardContent = ((0, jsx_runtime_1.jsx)(material_1.CardContent, { sx: {
            p: "0 !important",
            background: "white",
        }, children: children }));
    return ((0, jsx_runtime_1.jsx)(material_1.Card, { sx: [
            (theme) => ({
                boxShadow: theme.boxShadows.xs,
                overflow: "hidden",
                borderRadius: 1.5,
            }),
            onClick
                ? (theme) => ({
                    "&:hover": {
                        boxShadow: theme.boxShadows.md,
                    },
                })
                : {},
            ...(Array.isArray(sx) ? sx : [sx]),
        ], children: onClick || href ? ((0, jsx_runtime_1.jsx)(material_1.CardActionArea, { ...(onClick ? { onClick } : { href }), LinkComponent: LinkComponent, disableRipple: true, disableTouchRipple: true, sx: [
                {
                    [`&:hover .${material_1.cardActionAreaClasses.focusHighlight}`]: {
                        opacity: 0,
                    },
                },
                ...(Array.isArray(actionSx) ? actionSx : [actionSx]),
            ], children: cardContent })) : (cardContent) }));
};
exports.WhiteCard = WhiteCard;
